    <div mat-dialog-content>
        <p><b>Cost Planning will be reset to default if you change this value.</b></p>
        <p>Do you want to continue?</p>
    </div>
    <div mat-dialog-actions>
        <button mat-flat-button type="button" color="primary" [mat-dialog-close]="true">Yes</button>
        <button  mat-flat-button type="button" color="primary" [mat-dialog-close]="false">No</button>
    </div>